import React from "react"

const LukeBarton = (
  <>
    <p>
    <strong>Social Media Manager</strong><br />
    </p>
    <p>Luke Barton is a senior and varsity swimmer at Boise High School. He is the Senior Patrol Leader of Boy Scouts of America Troop 100 and a Leadership Boise Academy Ambassador and Graduate of the Class of 2025. Luke has competed in the sport of fencing since age 8 and competed in the Junior Olympics for fencing each year from 2022 to 2025. Luke plays the viola for the Boise Philharmonic Youth Orchestra and enjoys snow skiing and snowmobiling.</p>
  </>
)

export default LukeBarton;
